import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";

const GetWithdrowRequest = () => {

    const [data, setData] = useState([]);
    const [summary, setSummary] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchWithdrawRequests();
    }, []);

    const fetchWithdrawRequests = async () => {
        try {
            const res = await axios.get(
                endPoint.getWithdrawRequests,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("SellerTokenData")}`,
                    },
                }
            );
            if (res.data.success) {
                setData(res.data.data);
                setSummary({
                    totalRequests: res.data.totalRequests,
                    totalRequested: res.data.totalRequested,
                    totalPending: res.data.totalPending,
                    totalApproved: res.data.totalApproved,
                    totalRejected: res.data.totalRejected,
                    totalHold :res.data.totalHold,
                    totalHoldReleased:res.data.totalHoldReleased,
                });
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "approved":
                return "bg-green-100 text-green-600";
            case "rejected":
                return "bg-red-100 text-red-600";
            default:
                return "bg-yellow-100 text-yellow-600";
        }
    };

    if (loading) return <div className="p-5">Loading...</div>;

    return (
        <div className="p-6 bg-gray-50 min-h-screen">

            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">

                <div className="bg-white p-4 rounded shadow">
                    <p className="text-gray-500">Total Requests</p>
                    <h2 className="text-xl font-bold">{summary.totalRequests}</h2>
                </div>

                <div className="bg-white p-4 rounded shadow">
                    <p className="text-gray-500">Total Requested</p>
                    <h2 className="text-xl font-bold">₹{summary.totalRequested}</h2>
                </div>

                <div className="bg-white p-4 rounded shadow">
                    <p className="text-gray-500">Pending Amount</p>
                    <h2 className="text-xl font-bold text-yellow-600">
                        ₹{summary.totalPending}
                    </h2>
                </div>

                <div className="bg-white p-4 rounded shadow">
                    <p className="text-gray-500">Approved Amount</p>
                    <h2 className="text-xl font-bold text-green-600">
                        ₹{summary.totalApproved}
                    </h2>
                </div>

                <div className="bg-white p-4 rounded shadow">
                    <p className="text-gray-500">Rejected Amount</p>
                    <h2 className="text-xl font-bold text-red-600">
                        ₹{summary.totalRejected}
                    </h2>
                </div>
                    
                    <div className="bg-white p-4 rounded shadow">
<p className="text-gray-500">Hold Amount</p>
<h2 className="text-xl font-bold text-red-600">
    ₹{summary.totalHold || 0}
</h2>
</div>
<div className="bg-white p-4 rounded shadow">
<p className="text-gray-500">Hold Released</p>
<h2 className="text-xl font-bold text-blue-600">
    ₹{summary.totalHoldReleased || 0}
</h2>
</div>
            </div>


            {/* Table */}
            <div className="bg-white rounded shadow p-4">

                <h2 className="text-lg font-semibold mb-4">
                    Withdraw Requests
                </h2>

                <table className="w-full border">

                    <thead className="bg-gray-100">
                        <tr>
                            <th className="p-3 text-left">Seller ID</th>
                            <th className="p-3 text-left">Amount</th>
                            <th>Approved</th>
                            <th>Hold</th>
                            <th>Hold Reason</th>
                            <th>Hold Released</th>
                            <th>Release Date</th>
                            <th className="p-3 text-left">Status</th>
                            <th className="p-3 text-left">Date</th>
                        </tr>
                    </thead>

                    <tbody>

                        {data.map((item) => (
                            <tr key={item._id} className="border-t">

                                <td className="p-3">
                                    {item.sellerId}
                                </td>

                                <td className="p-3 font-medium">
                                    ₹{item.amount}
                                </td>
                                <td>
                                    ₹{item.approvedAmount}
                                </td>

                                <td className="text-red-600 font-semibold">
                                    ₹{item.holdAmount}
                                </td>

                                <td>
                                    {item.holdReason ? item.holdReason : "-"}
                                </td>

                                <td>
                                    {item.holdReleased ? (
                                        <span className="text-green-600 font-semibold">
                                            Released
                                        </span>
                                    ) : (
                                        <span className="text-yellow-600">
                                            Pending
                                        </span>
                                    )}
                                </td>
                                <td>
                                    {item.holdReleaseDate
                                        ? new Date(item.holdReleaseDate).toLocaleDateString()
                                        : "-"}
                                </td>


                                <td className="p-3">
                                    <span className={`px-3 py-1 rounded-full text-sm ${getStatusColor(item.status)}`}>
                                        {item.status}
                                    </span>
                                </td>

                                <td className="p-3">
                                    {new Date(item.createdAt).toLocaleDateString()}
                                </td>

                            </tr>
                        ))}

                    </tbody>

                </table>

            </div>

        </div>
    );
};

export default GetWithdrowRequest;